/*
 * @Author: Hyman Choi
 * @Date: 2021-01-11 08:38:43
 * @LastEditTime: 2021-01-29 14:48:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \SIUI.Cloud.Medical.Web\src\store\modules\permission.js
 */
import {asyncRoutes, constantRoutes} from '@/router'
import {isVaild} from "@/utils/validate";

/**
 * Use meta.roles to determfine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(menuCodeList, route) {
    // if (route.meta && route.meta.roles) {
    //   return roles.some(module => route.meta.roles.includes(module))
    // } else {
    //   return true
    // }
    return isMenuCodeListIncludesRoute(menuCodeList, route) || isParentInMenuCodeList(menuCodeList, route.parent)
}

/**
 * menuCodeList只有menuCode，前面没有带/
 * 特殊处理http跳转的route path
 * @param menuCodeList
 * @param route
 * @returns {*}
 */
function isMenuCodeListIncludesRoute(menuCodeList, route) {
    if (route.path.startsWith("http://") || route.path.startsWith("https://")) {
        return menuCodeList.includes(route.path)
    }
    return menuCodeList.includes(route.path.replace("/", ""))
}

/**
 * 查找route的parent是否包含在menuCodeList里面，有则认为也有访问子路由权限，因后台页面设置没有到子页面那么细
 * @param menuCodeList
 * @param routeParent
 * @returns {boolean}
 */
function isParentInMenuCodeList(menuCodeList, routeParent) {
    if (!isVaild(routeParent)) {
        return false
    }
    for (let i = 0; i < menuCodeList.length; i++) {
        let menuItem = menuCodeList[i]
        for (let j = 0; j < routeParent.length; j++) {
            let routeParentItem = routeParent[j]
            if (menuItem === routeParentItem) {
                return true
            }
        }
    }
    return false;
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param menuCodeList
 */
export function filterAsyncRoutes(routes, menuCodeList) {
    const res = []

    routes.forEach(route => {
        const tmp = {...route}
        if (hasPermission(menuCodeList, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, menuCodeList)
            }
            res.push(tmp)
        }
    })

    return res
}

const state = {
    routes: [],
    addRoutes: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes
        state.routes = constantRoutes.concat(routes)
    }
}

function getAllMenuListCode(menuList) {
    let res = []
    menuList.forEach(menu => {
        const tmp = {...menu}
        res.push(menu.menuCode)
        if (menu.childMenuList !== null && menu.childMenuList.length > 0) {
            let childMenuList = getAllMenuListCode(menu.childMenuList);
            res = res.concat(childMenuList)
        }
    })
    return res;
}

function sortRoutes(routers, menuList) {

    //子路由排序
    for (let i = 0; i < routers.length; i++) {
        let route = routers[i]
        if (route.children != null && route.children.length > 0) {
            route.children = sortRoutes(route.children, menuList)
        }
    }

    //排序
    return routers.sort((a, b) => {
        let aSort = getMenuSort(a, menuList)
        let bSort = getMenuSort(b, menuList)
        // console.log(`sort in ${a.path} ${aSort} ${b.path} ${bSort}`)
        return aSort - bSort
    })
}

function getMenuSort(route, menuList) {
    // console.log(`---- getMenuSort ${route.path}`)
    for (let i = 0; i < menuList.length; i++) {
        let menu = menuList[i]
        // console.log(` --- for ${menu.menuCode} ${route.path.replace("/", "")}`)
        if (route.path.replace("/", "") === menu.menuCode) {
            // console.log(`  -- if getMenuSort ${menu.sort}`)
            return menu.sort
        } else {
            // console.log(`  -- else getMenuSort ${menu.menuCode}`)
            if (menu.childMenuList != null && menu.childMenuList.length > 0) {
                // console.log(`   - childMenuList getMenuSort ${menu.menuCode}`)
                let sortInChild = getMenuSort(route, menu.childMenuList)
                if (sortInChild >= 0) {
                    return sortInChild
                }
            }
        }
    }
    // console.log(`    return getMenuSort -1 ${route.path}`)
    return -1;
}

const actions = {
    generateRoutes({commit}, menuList) {
        return new Promise(resolve => {
            let accessedRoutes
            //判断当前角色的列表中，是否包含admin
            // if (roles.includes('超级管理员')) {
            //   //所有路由都可以被访问
            //   accessedRoutes = asyncRoutes || []
            // } else {
            //根据角色，过滤不能被访问的路由表
            let menuCodeList = getAllMenuListCode(menuList)
            menuCodeList.push('http://www.siui.com.cn/ax/')
            menuCodeList.push('*')
            let routers = filterAsyncRoutes(asyncRoutes, menuCodeList)
            accessedRoutes = sortRoutes(routers, menuList);
            // }
            commit('SET_ROUTES', accessedRoutes)
            //返回路由表
            resolve(accessedRoutes)
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
